(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-team-two"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var overlay = document.getElementById('bb-modal-overlay');
  var modalImg = document.getElementById('bb-modal-img');
  var modalName = document.getElementById('bb-modal-name');
  var modalBody = document.getElementById('bb-modal-body');
  var modalSocial = document.getElementById('bb-modal-social');

  function isValidUrl(str) {
    if (!str || str.trim() === '') return false;
    try {
      new URL(str.trim());
      return true;
    } catch(e) {
      return false;
    }
  }

  document.querySelectorAll('.bb-member-toggle').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var d = this.dataset;

      modalImg.src = d.image || '';
      modalImg.alt = d.name || '';
      if (!d.image) document.querySelector('.bb-modal-photo').style.display = 'none';
      else document.querySelector('.bb-modal-photo').style.display = '';

      modalName.textContent = d.hometown ? d.name + ': ' + d.hometown : d.name;

      var desc = d.description ? d.description.replace(/&lt;br&gt;/gi, '<br>').replace(/&lt;br \/&gt;/gi, '<br>') : '';

      var body = '';
      if (desc) body += '<div style="margin-bottom:8px;font-size:14px;line-height:1.6;">' + desc + '</div>';
      if (d.nickname && d.nickname.trim()) body += '<p><strong>Nickname:</strong> ' + d.nickname + '</p>';
      if (d.paddle && d.paddle.trim()) body += '<p><strong>Favorite Paddle:</strong> ' + d.paddle + '</p>';
      if (d.paddleSpot && d.paddleSpot.trim()) body += '<p><strong>Favorite Paddling Spot:</strong> ' + d.paddleSpot + '</p>';
      if (d.fishingSpot && d.fishingSpot.trim()) body += '<p><strong>Favorite Fishing Spot:</strong> ' + d.fishingSpot + '</p>';
      modalBody.innerHTML = body;

      var social = '';
      if (isValidUrl(d.instagram)) social += '<a href="' + d.instagram.trim() + '" target="_blank" rel="noopener" style="font-size:13px;text-decoration:underline;margin-right:16px;display:inline-block;">Instagram</a>';
      if (isValidUrl(d.facebook)) social += '<a href="' + d.facebook.trim() + '" target="_blank" rel="noopener" style="font-size:13px;text-decoration:underline;margin-right:16px;display:inline-block;">Facebook</a>';
      if (isValidUrl(d.youtube)) social += '<a href="' + d.youtube.trim() + '" target="_blank" rel="noopener" style="font-size:13px;text-decoration:underline;margin-right:16px;display:inline-block;">YouTube</a>';
      if (isValidUrl(d.tiktok)) social += '<a href="' + d.tiktok.trim() + '" target="_blank" rel="noopener" style="font-size:13px;text-decoration:underline;margin-right:16px;display:inline-block;">TikTok</a>';
      if (isValidUrl(d.website)) social += '<a href="' + d.website.trim() + '" target="_blank" rel="noopener" style="font-size:13px;text-decoration:underline;margin-right:16px;display:inline-block;">Website</a>';
      modalSocial.innerHTML = social;

      overlay.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
    });
  });

  document.querySelector('.bb-modal-close').addEventListener('click', closeModal);
  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) closeModal();
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeModal();
  });

  function closeModal() {
    overlay.setAttribute('hidden', '');
    document.body.style.overflow = '';
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-team"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var overlay = document.getElementById('bb-modal-overlay');
  var modalImg = document.getElementById('bb-modal-img');
  var modalName = document.getElementById('bb-modal-name');
  var modalBody = document.getElementById('bb-modal-body');
  var modalSocial = document.getElementById('bb-modal-social');

  function isValidUrl(str) {
    if (!str || str.trim() === '') return false;
    try {
      new URL(str.trim());
      return true;
    } catch(e) {
      return false;
    }
  }

  document.querySelectorAll('.bb-member-toggle').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var d = this.dataset;

      modalImg.src = d.image || '';
      modalImg.alt = d.name || '';
      if (!d.image) document.querySelector('.bb-modal-photo').style.display = 'none';
      else document.querySelector('.bb-modal-photo').style.display = '';

      modalName.textContent = d.hometown ? d.name + ': ' + d.hometown : d.name;

      var desc = d.description ? d.description.replace(/&lt;br&gt;/gi, '<br>').replace(/&lt;br \/&gt;/gi, '<br>') : '';

      var body = '';
      if (desc) body += '<div style="margin-bottom:8px;font-size:14px;line-height:1.6;">' + desc + '</div>';
      if (d.nickname && d.nickname.trim()) body += '<p><strong>Nickname:</strong> ' + d.nickname + '</p>';
      if (d.paddle && d.paddle.trim()) body += '<p><strong>Favorite Paddle:</strong> ' + d.paddle + '</p>';
      if (d.paddleSpot && d.paddleSpot.trim()) body += '<p><strong>Favorite Paddling Spot:</strong> ' + d.paddleSpot + '</p>';
      if (d.fishingSpot && d.fishingSpot.trim()) body += '<p><strong>Favorite Fishing Spot:</strong> ' + d.fishingSpot + '</p>';
      modalBody.innerHTML = body;

      var social = '';
      if (isValidUrl(d.instagram)) social += '<a href="' + d.instagram.trim() + '" target="_blank" rel="noopener" style="font-size:13px;text-decoration:underline;margin-right:16px;display:inline-block;">Instagram</a>';
      if (isValidUrl(d.facebook)) social += '<a href="' + d.facebook.trim() + '" target="_blank" rel="noopener" style="font-size:13px;text-decoration:underline;margin-right:16px;display:inline-block;">Facebook</a>';
      if (isValidUrl(d.youtube)) social += '<a href="' + d.youtube.trim() + '" target="_blank" rel="noopener" style="font-size:13px;text-decoration:underline;margin-right:16px;display:inline-block;">YouTube</a>';
      if (isValidUrl(d.tiktok)) social += '<a href="' + d.tiktok.trim() + '" target="_blank" rel="noopener" style="font-size:13px;text-decoration:underline;margin-right:16px;display:inline-block;">TikTok</a>';
      if (isValidUrl(d.website)) social += '<a href="' + d.website.trim() + '" target="_blank" rel="noopener" style="font-size:13px;text-decoration:underline;margin-right:16px;display:inline-block;">Website</a>';
      modalSocial.innerHTML = social;

      overlay.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
    });
  });

  document.querySelector('.bb-modal-close').addEventListener('click', closeModal);
  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) closeModal();
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeModal();
  });

  function closeModal() {
    overlay.setAttribute('hidden', '');
    document.body.style.overflow = '';
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["team-three"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var overlay = document.getElementById('bb-modal-overlay');
  var modalImg = document.getElementById('bb-modal-img');
  var modalName = document.getElementById('bb-modal-name');
  var modalBody = document.getElementById('bb-modal-body');
  var modalSocial = document.getElementById('bb-modal-social');

  document.querySelectorAll('.bb-member-toggle').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var d = this.dataset;

      modalImg.src = d.image || '';
      modalImg.alt = d.name || '';
      if (!d.image) document.querySelector('.bb-modal-photo').style.display = 'none';
      else document.querySelector('.bb-modal-photo').style.display = '';

      modalName.textContent = d.title ? d.name + ': ' + d.title : d.name;

      var body = '';
      if (d.description) body += '<p>' + d.description + '</p>';
      if (d.hometown) body += '<p><strong>Hometown:</strong> ' + d.hometown + '</p>';
      if (d.nickname) body += '<p><strong>Nickname:</strong> ' + d.nickname + '</p>';
      if (d.paddle) body += '<p><strong>Favorite Paddle:</strong> ' + d.paddle + '</p>';
      if (d.paddleSpot) body += '<p><strong>Favorite Paddling Spot:</strong> ' + d.paddleSpot + '</p>';
      if (d.fishingSpot) body += '<p><strong>Favorite Fishing Spot:</strong> ' + d.fishingSpot + '</p>';
      modalBody.innerHTML = body;

      var social = '';
      if (d.instagram) social += '<a href="' + d.instagram + '" target="_blank" rel="noopener">Instagram</a>';
      if (d.facebook) social += '<a href="' + d.facebook + '" target="_blank" rel="noopener">Facebook</a>';
      if (d.youtube) social += '<a href="' + d.youtube + '" target="_blank" rel="noopener">YouTube</a>';
      if (d.website) social += '<a href="' + d.website + '" target="_blank" rel="noopener">Website</a>';
      modalSocial.innerHTML = social;

      overlay.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
    });
  });

  document.querySelector('.bb-modal-close').addEventListener('click', closeModal);
  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) closeModal();
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeModal();
  });

  function closeModal() {
    overlay.setAttribute('hidden', '');
    document.body.style.overflow = '';
  }
});

  } catch(e) { console.error(e); }
})();
})();
